// extracted by mini-css-extract-plugin
export default {"no-data-placeholder":"NoDataPlaceholder_no-data-placeholder__l1gz3"};